/**
 * @generated SignedSource<<c7444bf78694ffa88e3b450b7571d85c>>
 * @relayHash 97c579efae3d53fdf04fb24bd9e41dec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a26df09afb87015beb814bd83b211612ea3e5234a6864a889c4060cda4a5e33c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { RequestTypesTableQuery } from './RequestTypesTableQuery.graphql';

const node: PreloadableConcreteRequest<RequestTypesTableQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a26df09afb87015beb814bd83b211612ea3e5234a6864a889c4060cda4a5e33c",
    "metadata": {},
    "name": "RequestTypesTableQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
